export function formatarOpcaoFilial(opcao) {
    if (!opcao || typeof opcao.label !== 'string') {
        return opcao;
    }

    const indiceUltimoSeparador = opcao.label.lastIndexOf(' - ');
    if (indiceUltimoSeparador === -1) {
        return opcao;
    }

    const nome = opcao.label.substring(0, indiceUltimoSeparador);
    const numero = opcao.label.substring(indiceUltimoSeparador + 3);

    return {
        ...opcao,
        label: `${numero} - ${nome}`
    };
}
